import script from "./SplashScreen.vue?vue&type=script&setup=true&lang=ts"
export * from "./SplashScreen.vue?vue&type=script&setup=true&lang=ts"

import "./SplashScreen.vue?vue&type=style&index=0&id=65bce096&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65bce096"]])

export default __exports__